import 'foundation-sites/js/entries/plugins/foundation.core';
import 'foundation-sites/js/entries/plugins/foundation.util.triggers';
import 'foundation-sites/js/entries/plugins/foundation.util.mediaQuery';
import 'foundation-sites/js/entries/plugins/foundation.util.keyboard';
import 'foundation-sites/js/entries/plugins/foundation.util.imageloader';
import 'foundation-sites/js/entries/plugins/foundation.interchange';
import 'foundation-sites/js/entries/plugins/foundation.offcanvas';
import 'foundation-sites/js/entries/plugins/foundation.drilldown';
import 'foundation-sites/js/entries/plugins/foundation.tabs';
import 'foundation-sites/js/entries/plugins/foundation.accordion';
import 'foundation-sites/js/entries/plugins/foundation.equalizer';


Foundation.Interchange.SPECIAL_QUERIES['retinaDefault'] = [
  'only screen and (-webkit-min-device-pixel-ratio: 2)',
  'only screen and (min--moz-device-pixel-ratio: 2)',
  'only screen and (-o-min-device-pixel-ratio: 2/1)',
  'only screen and (min-device-pixel-ratio: 2)',
  'only screen and (min-resolution: 192dpi)',
  'only screen and (min-resolution: 2dppx)'
].join(', ');


Foundation.Interchange.SPECIAL_QUERIES['retinaSmall'] = [
  'only screen and (min-width: 0em) and (-webkit-min-device-pixel-ratio: 2)',
  'only screen and (min-width: 0em) and (min--moz-device-pixel-ratio: 2)',
  'only screen and (min-width: 0em) and (-o-min-device-pixel-ratio: 2/1)',
  'only screen and (min-width: 0em) and (min-device-pixel-ratio: 2)',
  'only screen and (min-width: 0em) and (min-resolution: 192dpi)',
  'only screen and (min-width: 0em) and (min-resolution: 2dppx)'
].join(', ');


Foundation.Interchange.SPECIAL_QUERIES['retinaMedium'] = [
  'only screen and (min-width: 40.0625em) and (-webkit-min-device-pixel-ratio: 2)',
  'only screen and (min-width: 40.0625em) and (min--moz-device-pixel-ratio: 2)',
  'only screen and (min-width: 40.0625em) and (-o-min-device-pixel-ratio: 2/1)',
  'only screen and (min-width: 40.0625em) and (min-device-pixel-ratio: 2)',
  'only screen and (min-width: 40.0625em) and (min-resolution: 192dpi)',
  'only screen and (min-width: 40.0625em) and (min-resolution: 2dppx)'
].join(', ');


Foundation.Interchange.SPECIAL_QUERIES['retinaLarge'] = [
  'only screen and (min-width: 68.75em) and (-webkit-min-device-pixel-ratio: 2)',
  'only screen and (min-width: 68.75em) and (min--moz-device-pixel-ratio: 2)',
  'only screen and (min-width: 68.75em) and (-o-min-device-pixel-ratio: 2/1)',
  'only screen and (min-width: 68.75em) and (min-device-pixel-ratio: 2)',
  'only screen and (min-width: 68.75em) and (min-resolution: 192dpi)',
  'only screen and (min-width: 68.75em) and (min-resolution: 2dppx)'
].join(', ');


$(document).foundation();



// WEBPACK FOOTER //
// ./src/js/modules/foundation-config.js